import PropTypes from 'prop-types';
import Plan, { extendablePropTypes } from 'Classes/Plan';

class ExternalPlan extends Plan {
  static get TYPE() {
    return 'external';
  }

  static fromAPIResponse(res) {
    if (!res.data || res.data.type !== ExternalPlan.TYPE) {
      return new ExternalPlan();
    }
    return Object.assign(new ExternalPlan(), res.data.attributes, {
      id: res.id,
    });
  }

  constructor() {
    super();

    this.type = 'external';
  }
}

export default ExternalPlan;

export const propTypes = PropTypes.shape({
  ...extendablePropTypes,
});
